// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"52":"13c757b9","454":"f6e5d3c7","522":"605ee450","561":"b24b36ad","935":"940261c4","969":"5739f921"}[chunkId] + ".css";
};